import {Http, Response, ResponseContentType} from '@angular/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ReportFilteringModel} from "../../../../+configuration/aml_rules/api";
import {
    CheckFullTransHistory,
    ProviderReportFilteringModel
} from "../../../../+configuration/provider_reports/api/entity";
import {get} from "lodash";
import {MoorwandPaymentExcel} from "../../../../../shared/api/entity/transfer/moorwand.payment.history.i";
import {
    MoorwandReconciliationReportExcel
} from "../../../../processing/+manual-controls/api/entity/moorwand-reconciliation-report.model";

@Injectable()
export class FileDownloadService {

    private BO_API_PATH = '/api/backoffice';

    constructor(private _http: Http) {
    }

    private getApiRootPath() {
        return this.BO_API_PATH;
    }

    downloadFile(fileId: string): Observable<Response> {
        return this._http.get(`${this.getApiRootPath()}/download/attachment/${fileId}`,
            {responseType: ResponseContentType.Blob})
    }

    downloadAttachmentsFile(fileIds: string[], fileName: string): Observable<Response> {
        return this._http.get(`${this.getApiRootPath()}/download/attachment-items/${fileIds}/attachments-name/${fileName}`,
            {responseType: ResponseContentType.Blob})
    }

    downloadAllCorporateAttachmentsFile(profileId: number, fileName: string) {
        return this._http.get(`${this.getApiRootPath()}/corporate-accounts/${profileId}/attachments?all&download`,
            {
                params: {fileName},
                responseType: ResponseContentType.Blob
            });
    }

    downloadCRAFile(profileId: number, fileName: string): Observable<Response> {
        return this._http.get(`${this.getApiRootPath()}/download/cra/${profileId}`,
            {
                responseType: ResponseContentType.Blob
            });
    }

    downloadNeocheckReport(profileId: number): Observable<Response> {
        return this._http.get(`${this.getApiRootPath()}/verification/report/${profileId}`,
            {
                responseType: ResponseContentType.Blob
            });
    }

    downloadNeocheckDirectorsShareholdersReport(id: number, type: string): Observable<Response> {
        return this._http.get(`${this.getApiRootPath()}/verification/director-shareholder/${id}/report/${type}`,
            {
                responseType: ResponseContentType.Blob
            });
    }

    downloadDailyBalanceReport(): Observable<Response> {
        return this._http.get(`${this.getApiRootPath()}/customers/balance/report/`,
            {
                responseType: ResponseContentType.Blob
            });
    }

    downloadDailyBalanceFilterReport(model: {}): Observable<Response> {
        const from = get(model, 'date.from', null);
        const to = get(model, 'date.to', null);
        const DATE_PATTERN = /^\d{2}\.\d{2}\.\d{4}$/;
        if (!from || !to || !DATE_PATTERN.test(from) || !DATE_PATTERN.test(to)) {
            throw new Error('Invalid date format in balance report filter');
        }
        return this._http.post(`${this.getApiRootPath()}/customers/balance/report/filter`,
            {
                period: { from, to }
            }, {
                responseType: ResponseContentType.Blob
            });
    }

    downloadPaymentReport(): Observable<Response> {
        return this._http.get(`${this.getApiRootPath()}/transfers/outgoing/report/outgoing`,
            {
                responseType: ResponseContentType.Blob
            });
    }

    downloadAmlRulesPaymentReport(filterModel: ReportFilteringModel): Observable<Response> {
        return this._http.get(`${this.getApiRootPath()}/aml-rules/aml/report`, {
            params: filterModel,
            responseType: ResponseContentType.Blob
        });
    }

    downloadCustomReport(ruleId: number): Observable<Response> {
        return this._http.get(`${this.getApiRootPath()}/aml-rules/aml/report/${ruleId}`,
            {
                responseType: ResponseContentType.Blob
            });
    }

    downloadProviderReport(filterModel: ProviderReportFilteringModel): Observable<Response> {
        return this._http.post(`${this.getApiRootPath()}/provider-reports/report`, filterModel, {
            responseType: ResponseContentType.Blob
        });
    }

    generateProviderMIReport(filterModel: ProviderReportFilteringModel): Observable<any> {
        return this._http.patch(`${this.getApiRootPath()}/provider-reports/report/`, filterModel, {});
    }


    downloadMoorwandPaymentsExcel(payments: MoorwandPaymentExcel[]): Observable<Response> {
        return this._http.post(`${this.getApiRootPath()}/provider-reports/moorwand-payments/excel`, payments,
            {
                responseType: ResponseContentType.Blob
            });
    }

    downloadMoorwandReconciliationReportExcel(payments: MoorwandReconciliationReportExcel[]): Observable<Response> {
        return this._http.post(`${this.getApiRootPath()}/provider-reports/moorwand-reconciliation-report/excel`, payments,
            {
                responseType: ResponseContentType.Blob
            });
    }

    validateProviderFullTransactionReport(reportFilter: ProviderReportFilteringModel): Observable<CheckFullTransHistory> {
        return this._http.post(`${this.getApiRootPath()}/provider-reports/report/check-full-trans-hist`, reportFilter)
            .map(response => response.json());
    }

    downloadDailyChechPepReport(fileName: string): Observable<Response> {
        return this._http.post(`${this.getApiRootPath()}/check-pep/pep-reports/download`,
            {
                fileName: fileName
            }, {
                responseType: ResponseContentType.Blob
            });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/service/file.download.service.ts